import { IAddress } from "~/interfaces";

export const ADDRESSES: IAddress = {
	obla: {
		streetName: "Oblá",
		houseNumber: "447/57",
		zipCode: 63400,
		city: "Brno - Nový Lískovec",
	},
	seznamCampus: {
		firm: "Seznam a.s.",
		building: "budova 4C",
		streetName: "Palachovo nám.",
		houseNumber: "797/4C",
		zipCode: 62500,
		city: "Brno-Starý Lískovec",
	},
	bojanoviceTatka: {
		streetName: "Střední Pustá",
		houseNumber: "729",
		zipCode: 69617,
		city: "Dolní Bojanovice",
	},
	bojanoviceMrakovi: {
		streetName: "Zvolence",
		houseNumber: "840",
		zipCode: 69617,
		city: "Dolní Bojanovice",
	},
	bojanoviceMakuderovi: {
		streetName: "Kyjovská",
		houseNumber: "605",
		zipCode: 69617,
		city: "Dolní Bojanovice",
	},
	mutenice: {
		streetName: "Údolní",
		houseNumber: "766",
		zipCode: 69611,
		city: "Mutěnice",
	},
	priborRodice: {
		streetName: "Bezručova",
		houseNumber: "1579",
		zipCode: 74258,
		city: "Příbor",
	},
	priborBryknarovi: {
		streetName: "Štramberská",
		houseNumber: "431",
		zipCode: 74258,
		city: "Příbor",
	},
	frydekMistek: {
		streetName: "Maxe Švabinského",
		houseNumber: "2235",
		zipCode: 73801,
		city: "Frýdek-Místek - Frýdek",
	},
	praha: {
		streetName: "Libušská",
		houseNumber: "234",
		zipCode: 14200,
		city: "Praha 4 - Libuš",
	},
	liberec: {
		streetName: "",
		houseNumber: "",
		zipCode: 0,
		city: "Liberec",
	},
	koprivnice: {
		streetName: "Ke Koryčce",
		houseNumber: "877/1",
		zipCode: 74221,
		city: "Kopřivnice",
	},
	lichnovTeta: {
		streetName: "Lichnov",
		houseNumber: "201",
		zipCode: 74275,
		city: "Lichnov",
	},
	lichnovVlada: {
		streetName: "Lichnov",
		houseNumber: "506",
		zipCode: 74275,
		city: "Lichnov",
	},
	znojmoBabicka: {
		streetName: "Dukelských bojovníků",
		houseNumber: "3459/148",
		zipCode: 67181,
		city: "Znojmo",
	},
	znojmoRuzicka: {
		streetName: "Jarošova",
		houseNumber: "1444/22",
		zipCode: 66902,
		city: "Znojmo",
	},
	hodoninMamka: {
		streetName: "Lesní",
		houseNumber: "3292/7",
		zipCode: 69501,
		city: "Hodonín",
	},
};
